// validators.service.ts
import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class CustomValidatorsService {
    
  atLeastOneFieldFilled(field1: string, field2: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const control1 = formGroup.get(field1);
      const control2 = formGroup.get(field2);

      if (!control1 || !control2) return null;

      const value1 = control1.value;
      const value2 = control2.value;

      return value1 || value2 ? null : { atLeastOneRequired: true };
    };
  }

}
